import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
